import {
    RECEIVE_CONFIG_SITE
} from '../actions/action-types';

export default function config(state = {}, action) {
    switch (action.type) {
        case RECEIVE_CONFIG_SITE:
            return {
                ...state,
                site: action.site,
                context: action.context
            };
        default:
            return state;
    }
}
